import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DataGrid, Icon, IconButton, Spacer, Stack, Tooltip, Typography } from '@emburse/embark-core';
import { CheckIcon, UndoIcon } from '@emburse/embark-icons';
import dayjs from 'dayjs';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { useERPGatewayExport } from '../../../components/ERPGateway/ERPGatewayExportProvider';
function ERPGatewayPendingExportsDataGrid({ data, isActiveStatus, isSyncPending, onExport }) {
    useTranslation();
    const { setSelectedRows, getExpenseReportUrl, catchError } = useERPGatewayExport();
    const openUrl = async (id) => {
        try {
            const url = await getExpenseReportUrl(id);
            window.open(url, '_blank');
        }
        catch (error) {
            catchError(error);
        }
    };
    const onRowSelect = (selectionIds) => {
        setSelectedRows(selectionIds);
    };
    const columns = () => [
        {
            field: 'EmployeeName',
            headerName: $t('User'),
            flex: 1,
            type: 'string'
        },
        {
            field: 'Name',
            headerName: $t('Report Name'),
            flex: 1,
            type: 'string'
        },
        {
            field: 'ApprovalCode',
            headerName: $t('Approval Code'),
            flex: 1,
            type: 'string'
        },
        {
            field: 'ProcessedDate',
            headerName: $t('Date'),
            flex: 1,
            minWidth: 200,
            type: 'string',
            renderCell: (cell) => (_jsx(Typography, { variant: "body2", children: `${dayjs(cell.value).format('ddd L')}` }))
        },
        {
            field: '',
            headerName: '',
            width: 135,
            renderCell: (cell) => (_jsxs(Stack, { direction: "row", spacing: 0, justifyContent: "space-between", children: [_jsx(Tooltip, { title: $t('Unprocess report. This will allow you to make changes to the report before it is exported'), placement: "top", children: _jsx(IconButton, { color: "primary", disabled: !isActiveStatus || isSyncPending, onClick: () => openUrl(cell.row.id), children: _jsx(Icon, { iconUrl: UndoIcon }) }) }), _jsx(Tooltip, { title: $t('Mark as exported. The report will be excluded from future exports and will be removed from this queue'), placement: "top", children: _jsx(IconButton, { color: "primary", disabled: !isActiveStatus || isSyncPending, onClick: () => onExport(cell.row.id), children: _jsx(Icon, { iconUrl: CheckIcon }) }) })] }))
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(DataGrid, { autoHeight: true, columns: columns(), rows: data, allowSelection: true, disableRowSelectionOnClick: true, onRowSelectionModelChange: onRowSelect, localeText: {
                    noRowsLabel: $t('There are currently no reports pending export. Expense reports will appear here after they are processed, and before they are exported to your external system.')
                } }), _jsx(Spacer, { size: 20 })] }));
}
export default ERPGatewayPendingExportsDataGrid;
